<template>
  <section id="jobs" class="py-16 bg-white">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark">就业创业</h2>
        <p class="mt-4 text-gray-medium max-w-2xl mx-auto">精选优质企业职位，提供全方位就业服务，助力您找到理想工作</p>
      </div>

      <!-- 错误提示 -->
      <div v-if="error" class="text-center py-6 mb-8">
        <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 max-w-md mx-auto">
          <div class="flex items-center justify-center mb-2">
            <i class="fas fa-exclamation-triangle text-yellow-500 text-lg mr-2"></i>
            <h3 class="text-sm font-semibold text-yellow-800">离线模式</h3>
          </div>
          <p class="text-yellow-700 text-xs">{{ error }}</p>
        </div>
      </div>

      <!-- 职位列表 -->
      <div class="space-y-6">
        <div 
          v-for="job in jobs" 
          :key="job.job_id"
          @click="viewJobDetail(job.job_id)"
          class="bg-white rounded-xl overflow-hidden shadow-card hover:shadow-card-hover transition-custom border border-gray-100 cursor-pointer"
        >
          <div class="p-6">
            <div class="flex flex-col md:flex-row md:items-center">
              <div class="flex items-center mb-4 md:mb-0">
                <!-- <img :src="$getImageUrl(job.company_logo)" :alt="job.company_name" class="w-16 h-16 rounded-lg object-cover"> -->
                <div class="ml-4">
                  <h3 class="font-bold text-lg text-dark">{{ job.title }}</h3>
                  <p class="text-gray-medium">{{ job.company_name }} · {{ job.location }}</p>
                </div>
              </div>
              <div class="flex-1 md:pl-8 md:text-right">
                <div class="text-primary font-bold text-lg mb-2">{{ job.salary }}</div>
                <!-- <div class="flex flex-wrap justify-end gap-2">
                  <span 
                    v-for="tag in job.benefits" 
                    :key="tag"
                    class="bg-light text-gray-dark text-xs px-2 py-1 rounded-full"
                  >
                    {{ tag }}
                  </span>
                </div> -->
              </div>
            </div>
            <div class="mt-4 pt-4 border-t border-gray-100">
              <!-- <div class="flex flex-wrap gap-3 mb-4">
                <span 
                  v-for="skill in job.skills" 
                  :key="skill"
                  class="bg-primary/10 text-primary text-xs px-3 py-1 rounded-full"
                >
                  {{ skill }}
                </span>
              </div> -->
              <div class="flex justify-between items-center">
                <p class="text-sm text-gray-medium">发布时间：{{ formatDate(job.updatetime) }}</p>
                <button @click.stop="viewJobDetail(job.job_id)" class="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/90 transition-custom text-sm font-medium">
                  查看职位
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 加载更多 -->
      <div class="mt-10 text-center">
        <button 
          @click="goToJobsPage"
          class="px-6 py-3 bg-white border border-gray-light rounded-lg text-gray-dark font-medium hover:bg-light transition-custom flex items-center mx-auto"
        >
          <span>查看更多职位</span>
          <i class="fas fa-arrow-right ml-2"></i>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { jobAPI } from '@/api/services'

export default {
  name: 'JobsSection',
  data() {
    return {
      jobs: [],
      error: null
    }
  },
  async mounted() {
    await this.loadJobs()
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '-'
      
      const date = new Date(timestamp * 1000) // 如果是秒级时间戳，需要乘以1000
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      
      return `${year}-${month}-${day}`
    },
    
    async loadJobs() {
      this.error = null
      
      try {
        const response = await jobAPI.getJobs({ 
          page: 1, 
          limit: 3 
        })
        this.jobs = response.data || response
      } catch (error) {
        console.error('加载职位失败:', error)
        this.error = error.msg || error.message || '服务器连接失败，无法加载职位数据'
        this.jobs = []
      }
    },
    
    viewJobDetail(jobId) {
      this.$router.push(`/job/${jobId}`)
    },
    
    goToJobsPage() {
      window.open('https://www.rongyuezhiya.com/', '_blank', 'noopener,noreferrer')
    }
  }
}
</script>

<style lang="less" scoped>
.transition-custom {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style> 